import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import Src from '@learningblocks/exp-constants/lib/Images/power_supply_image.svg';
import {AnodeCathodeSlot} from './AnodeCathodeSlot';

import './style.scss';

export function PSImage(props) {
  return (
    <div className='psImage'>
      <Image className='psImage_image' src={Src} onClick={props.onClick} />
      <AnodeCathodeSlot className='psImage_bottomBlock' />
    </div>
  );
}

PSImage.propTypes = {
  /**
   * callback fucntion to trigger on click
   */
  onClick: PropTypes.func,
};
